import { useEffect, useState, useCallback } from 'react';
import { Trash2, Plus } from 'lucide-react';
import { supabase } from '../../supabaseClient';

function slugify(s) {
  return s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export default function AdminCategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    const { data, error: err } = await supabase.from('categories').select('*').order('sort_order');
    if (err) setError(err.message);
    setCategories(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const addCategory = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const { error: err } = await supabase.from('categories').insert({
      name: name.trim(),
      slug: slugify(name),
      sort_order: categories.length,
    });
    if (err) { setError(err.message); return; }
    setName('');
    setError('');
    load();
  };

  const removeCategory = async (id) => {
    const { error: err } = await supabase.from('categories').delete().eq('id', id);
    if (err) { setError(err.message); return; }
    load();
  };

  if (loading) return <div>Loading…</div>;

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: 20 }}>Categories</h1>

      <form onSubmit={addCategory} style={{ display: 'flex', gap: 10, marginBottom: 24, maxWidth: 420 }}>
        <input
          className="sv-input"
          placeholder="e.g. Sealed product"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button type="submit" className="sv-btn" style={{ flexShrink: 0 }}>
          <Plus size={16} /> Add
        </button>
      </form>

      {error && <div style={{ color: 'var(--danger)', marginBottom: 16, fontSize: '0.85rem' }}>{error}</div>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 500 }}>
        {categories.map((c) => (
          <div
            key={c.id}
            className="sv-card"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px' }}
          >
            <div>
              <div style={{ fontWeight: 700 }}>{c.name}</div>
              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>/{c.slug}</div>
            </div>
            <button onClick={() => removeCategory(c.id)} className="sv-btn-outline" style={{ padding: 8, borderRadius: 999 }}>
              <Trash2 size={15} />
            </button>
          </div>
        ))}
        {categories.length === 0 && <div style={{ color: 'var(--text-muted)' }}>No categories yet.</div>}
      </div>
    </div>
  );
}
